import { useState } from "react";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Consulting() {
  const [form, setForm] = useState({
    full_name: "", email: "", phone: "", company: "", scope: "", description: "", budget_range: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/consulting", form);
      setSubmitted(true);
      toast.success("Consulting inquiry received.");
    } catch { toast.error("Submission failed."); }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="consulting-page">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Advisory</div>
      <h1 className="display-black text-5xl lg:text-6xl uppercase text-[#064E3B] mt-3 tracking-tighter">Consulting for large jobs.</h1>
      <p className="text-gray-700 mt-4 max-w-2xl">
        We advise municipalities, fleet liquidators, and asset managers on complex removal programs. Title resolution, environmental compliance, multi-jurisdiction logistics — done.
      </p>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <div className="border border-gray-300 p-7">
            <h3 className="display-black text-xl uppercase text-[#064E3B]">What we deliver</h3>
            <ul className="mt-4 space-y-3 text-sm text-gray-800">
              <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Project scoping + cost modelling</li>
              <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Carrier RFP design and bid management</li>
              <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Title resolution & DOT/FAA/CCG compliance</li>
              <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Salvage recovery + scrap pricing strategy</li>
              <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> On-site coordination across 30,000+ cities</li>
            </ul>
          </div>
        </div>

        {submitted ? (
          <div className="border border-[#064E3B] p-10 bg-gray-50" data-testid="consulting-success">
            <div className="display-black text-2xl uppercase text-[#064E3B]">★ Inquiry received</div>
            <p className="text-gray-700 mt-3">A senior advisor will reach out within 1 business day with next steps.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-5 border border-gray-300 p-8" data-testid="consulting-form">
            <input className="input-federal" required placeholder="Full name" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} data-testid="con-name" />
            <input className="input-federal" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="con-email" />
            <input className="input-federal" required placeholder="Phone" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} data-testid="con-phone" />
            <input className="input-federal" placeholder="Company / Agency" value={form.company} onChange={e => setForm({...form, company: e.target.value})} data-testid="con-company" />
            <input className="input-federal md:col-span-2" required placeholder="Scope (one line)" value={form.scope} onChange={e => setForm({...form, scope: e.target.value})} data-testid="con-scope" />
            <input className="input-federal md:col-span-2" placeholder="Budget range (optional)" value={form.budget_range} onChange={e => setForm({...form, budget_range: e.target.value})} data-testid="con-budget" />
            <textarea className="input-federal md:col-span-2" rows={5} required placeholder="Describe the project, jurisdiction, timeline…" value={form.description} onChange={e => setForm({...form, description: e.target.value})} data-testid="con-desc" />
            <button type="submit" className="btn-federal md:col-span-2 justify-center" data-testid="con-submit">Submit Inquiry <ArrowRight className="w-4 h-4" /></button>
          </form>
        )}
      </div>
    </div>
  );
}
